export default __webpack_public_path__ + "static/media/error@2x.27468beb.png";